/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 *
 * Where a user lands. The apps in nav order, each with the grant its nav link and
 * page check; the first one the user holds is home. Pages that refuse a user send
 * them here too, so the redirect never points at another page they can't open.
 */

type HasPermission = (permission: string) => boolean

export const NO_APPS_PATH = '/no-apps'

const APPS: { path: string; allowed: (has: HasPermission) => boolean }[] = [
  { path: '/assets', allowed: (has) => has('assetMap') },
  { path: '/trackers', allowed: (has) => has('preview') || has('trackerMap') },
  { path: '/cold-storage', allowed: (has) => has('coldStorage') },
  { path: '/audit-logs', allowed: (has) => has('auditLogs') },
]

/** The first app the user can open, or the no-apps page. */
export const firstAppPath = (hasPermission: HasPermission): string =>
  APPS.find((app) => app.allowed(hasPermission))?.path ?? NO_APPS_PATH
